// [APP-FORK] 앱 전용 가드 — verifysuccess 라우트에만 적용.
//   검증은 앱 QR 스캐너로만 하므로 웹에서 이 화면에 도달할 정상 경로가 없다.
//   user-app 의 AppOnlyGuard.tsx 와 달리 PC 도 막는다(웹 검증 업무가 없음).
//   판정은 UA 단독 — utils/isApp.js 참조.
import React from 'react';

import { isApp } from '../utils/isApp';
import { androidAppPackage, iosAppScheme, storeUrlForOs } from './AppLinkLanding';

export default function AppOnlyGuard({ children }) {
  // UA 동기 판정이라 첫 렌더에 확정 → 차단 시 children 이 마운트되지 않는다.
  if (isApp()) return <>{children}</>;

  const onOpenApp = () => {
    const { host, pathname, search } = window.location;
    const ua = typeof navigator !== 'undefined' ? navigator.userAgent || '' : '';
    if (/iphone|ipad|ipod/i.test(ua)) {
      // ★같은 https 주소를 window.location.href 로 재대입해도 Universal Link 는 안 뜬다 —
      //  iOS 는 페이지 내부 JS 네비게이션을 앱 전환 대상으로 취급하지 않는다(Safari 밖에서의
      //  탭에서만 동작). 그래서 예전엔 이 버튼을 눌러도 같은 페이지가 새로고침만 됐다.
      //  커스텀 스킴({scheme}://mobile{pathname})으로 우회 — app_shell.dart _handleDeepLink 의
      //  '{scheme}://mobile/...' 분기가 받아 adminBase+path 로 그대로 로드한다.
      //  scheme 은 iosAppScheme() 로 환경별 분기(naegift-mobile-app AppConfig.urlScheme 과 일치 필수).
      window.location.href = `${iosAppScheme()}:/${pathname}${search}`;
      return;
    }
    // 앱 미설치 시 fallback_url 이 없으면 크롬이 "항목을 찾을 수 없습니다" 에러페이지를 띄운다.
    //  원래 페이지로 되돌려 차단 화면이 다시 보이게 한다.
    const fbUrl = encodeURIComponent(window.location.href);
    window.location.href =
      `intent://${host}${pathname}${search}#Intent;scheme=https;package=${androidAppPackage()};S.browser_fallback_url=${fbUrl};end`;
  };

  const onInstallApp = () => {
    const url = storeUrlForOs();
    if (url) window.location.href = url;
  };

  const wrapStyle = {
    minHeight: '60vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 16,
    padding: 24,
    textAlign: 'center',
  };

  return (
    <div style={wrapStyle}>
      <div style={{ fontSize: 40 }}>🎁</div>
      <p style={{ fontSize: 16, color: '#333' }}>내기프트 앱에서 열어주세요</p>
      <p style={{ fontSize: 13, color: '#888' }}>
        이 페이지는 내기프트 앱에서 확인하실 수 있어요.
      </p>
      <button
        type="button"
        onClick={onOpenApp}
        style={{ padding: '10px 20px', borderRadius: 8, border: 'none',
                 background: '#8AAAE5', color: '#fff', fontSize: 15, cursor: 'pointer' }}
      >
        앱에서 열기
      </button>
      <button
        type="button"
        onClick={onInstallApp}
        style={{ padding: '10px 20px', borderRadius: 8, border: '1px solid #8AAAE5',
                 background: '#fff', color: '#8AAAE5', fontSize: 15, cursor: 'pointer' }}
      >
        앱 설치하기
      </button>
    </div>
  );
}
